import { render, staticRenderFns } from "./TeamCommittedData.vue?vue&type=template&id=1ab24b1e&"
import script from "./TeamCommittedData.vue?vue&type=script&lang=ts&"
export * from "./TeamCommittedData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports